// 长内容的表单组件的内容
// 要求父项目存在antd
// write by cursor

import React from "react";
import { Tooltip } from "antd";

// 使用 React.memo 进行性能优化
const LongTxtLabel = React.memo<LongTxtLabelProps>(({
  label,
  style = {},
  tooltipTitle,
  showTooltip = true,
  placement = "top",
}) => {
  // 默认样式 - 保持简洁，避免布局问题
  const defaultStyle: React.CSSProperties = {
    whiteSpace: "nowrap",
    display: "inline-block",
    verticalAlign: "middle",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "120px"
  };

  // 合并样式
  const mergedStyle = { ...defaultStyle, ...style };

  const content = (
    <span style={mergedStyle}>
       {label}
    </span>
  );

  // 如果不显示tooltip，直接返回span
  if (!showTooltip) {
    return content;
  }

  return (
    <Tooltip
      title={tooltipTitle || label}
      placement={placement}
    >
      {content}
    </Tooltip>
  );
});

LongTxtLabel.displayName = 'LongTxtLabel';

export interface LongTxtLabelProps {
  /** 要显示的文本内容 */
  label: string;
  /** 自定义样式，会合并到默认样式中 */
  style?: React.CSSProperties;
  /** Tooltip的标题，如果不提供则使用label */
  tooltipTitle?: string;
  /** 是否显示Tooltip，默认true */
  showTooltip?: boolean;
  /** Tooltip的placement */
  placement?: "top" | "left" | "right" | "bottom" | "topLeft" | "topRight" | "bottomLeft" | "bottomRight" | "leftTop" | "leftBottom" | "rightTop" | "rightBottom";
}


export default LongTxtLabel;
